export const SET_COLUMN_DATA       = 'SET_COLUMN_DATA';
export const CLEAR_COLUMN_DATA     = 'CLEAR_COLUMN_DATA';
export const CLEAR_ALL_COLUMN_DATA = 'CLEAR_ALL_COLUMN_DATA';
export const SET_FILTER_CONFIG = 'SET_FILTER_CONFIG';
